// src/client/components/profile-manager/detail-view/StatusMarkersSection.tsx

import ToggleField from './ToggleField';
import type { ProfileWithRelations } from '@shared/types';

interface StatusMarkersSectionProps {
  profile: ProfileWithRelations;
  onUpdate: (updates: Partial<ProfileWithRelations>) => Promise<void>;
}

export default function StatusMarkersSection({
  profile,
  onUpdate,
}: StatusMarkersSectionProps) {
  return (
    <div className="border rounded-lg p-4 bg-white">
      <h3 className="text-lg font-semibold mb-4">Status Markers</h3>
            
      <ToggleField
        label="Active"
        checked={profile.isActive || false}
        onToggle={(checked) => onUpdate({ isActive: checked })}
      />
      
      <ToggleField
        label="Blocked"
        checked={profile.isBlocked || false}
        onToggle={(checked) => onUpdate({ isBlocked: checked })}
      />
      
      <ToggleField
        label="Checked"
        checked={profile.isChecked || false}
        onToggle={(checked) => onUpdate({ isChecked: checked })}
      />
    </div>
  );
}